import styled from 'styled-components'
import { variantStyles } from '../../../components/Basics/Typography.styles'

export const Container = styled.section`
  grid-area: experience;
  margin-inline-end: 1rem;
  margin-inline-start: 1rem;
  margin-top: 2rem;
`

export const Timeline = styled.ol`
  border-inline-start: 1px solid ${({ theme }) => theme.colors.borderDefault};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xl};
  list-style: none;
  margin: ${({ theme }) => theme.spacing.lg} 0 0;
  padding: 0 0 0 ${({ theme }) => theme.spacing.lg};
`

export const Entry = styled.li`
  position: relative;

  &::before {
    background: ${({ theme }) => theme.colors.borderStrong};
    border-radius: ${({ theme }) => theme.borderRadius.full};
    content: '';
    height: 8px;
    left: calc(-1 * ${({ theme }) => theme.spacing.lg} - 4.5px);
    position: absolute;
    top: 0.45rem;
    width: 8px;
  }
`

export const Role = styled.h2`
  margin: 0 0 ${({ theme }) => theme.spacing.xs};
  ${({ theme }) => variantStyles({ variant: 'h5', theme })}
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 600;
`

export const Meta = styled.p`
  margin: 0 0 ${({ theme }) => theme.spacing.sm};
  ${({ theme }) => variantStyles({ variant: 'caption', theme })}
`

export const Summary = styled.p`
  margin: 0;
  ${({ theme }) => variantStyles({ variant: 'body2', theme })}
  line-height: 1.7;
`
